import { CRMLabels, CRMProFlexLabels } from '@dtx-company/true-common/src/types/crmThirdParty'
import {
  DemoModalVariants as DMV,
  DemoModalEnterpriseVariants,
  DemoModalProFlexVariants
} from '@dtx-company/true-common/src/types/demoModal'
import {
  DemoModalCodeLimit,
  DemoModalGeolocation,
  DemoModalHubspotCRM,
  DemoModalPermissionSharing,
  DemoModalProFlexFlowteams,
  DemoModalUnlimitedPlatformSeats
} from '@app/code/src/assets'
import { MarketingPageRoutes, Routes } from '@dtx-company/true-common/src/constants/routes'
import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { getPlanTypeName } from '../utils/getPlanTypeName'

export type DemoModalVariants =
  | CRMProFlexLabels
  | DemoModalProFlexVariants
  | DemoModalEnterpriseVariants
export const DemoModalVariants = {
  ...CRMProFlexLabels,
  ...DemoModalProFlexVariants,
  ...DemoModalEnterpriseVariants
}

export const DemoModalNavLinkVariants: {
  [key: string]: DMV
} = {
  'My Org': DemoModalVariants.ENTERPRISE_FLOWTEAMS_UPSELL
}

export const DemoModalCRMVariants: {
  [key in CRMLabels]?: DMV
} = {
  [CRMLabels.HUBSPOT]: DemoModalVariants.HUBSPOT
}

export const DemoModalDefaultButtonLabel = 'Book a demo'
export const DemoModalDefaultRedirectRoute = MarketingPageRoutes.CONTACT_SALES

const ProFlexPlanTypeName = getPlanTypeName(PlanType.PRO_FLEX)

export const DemoModalGraphics: Record<
  DMV,
  {
    version?: 'v1' | 'v2'
    header: string
    graphic: string
    footer?: string
    margin?: string
    buttonLabel?: string
    cancelButton?: boolean
    route?: Routes
  }
> = {
  [DemoModalVariants.HUBSPOT]: {
    header: `Upgrade to ${ProFlexPlanTypeName} to manage your CRM with Hubspot`,
    graphic: DemoModalHubspotCRM,
    footer:
      'Harness the power of excellent customer relationship manaegment with Hubspot integration.'
  },
  [DemoModalVariants.PRO_FLEX_FLOWTEAMS_UPSELL]: {
    header: `Upgrade to ${ProFlexPlanTypeName} for FlowTeams`,
    graphic: DemoModalProFlexFlowteams,
    footer:
      'Many hands make light work. Collaborate across multiple projects with a team. Organize your team and add up to 10 seats.'
  },
  [DemoModalVariants.PRO_FLEX_FLOWTEAMS_UPSELL_USE_CASE]: {
    header: `Upgrade to ${ProFlexPlanTypeName} for FlowTeams`,
    graphic: DemoModalProFlexFlowteams,
    footer:
      'Many hands make light work. Collaborate across multiple projects with a team. Organize your team and add up to 10 seats.',
    buttonLabel: 'Learn more',
    route: Routes.PRO_FLEX
  },
  [DemoModalVariants.ENTERPRISE_FLOWTEAMS_UPSELL]: {
    header: `Upgrade to ${getPlanTypeName(PlanType.ENTERPRISE)} for Unlimited Platform Seats`,
    graphic: DemoModalUnlimitedPlatformSeats,
    footer:
      'Unlock an unlimited amount of platform seats for your organization to seamlessly collaborate and organize across projects at scale. Harness admin access to manage sharing permissions within your organization'
  },
  [DemoModalVariants.PRO_FLEX_GEOLOCATION]: {
    header: `Upgrade to ${ProFlexPlanTypeName} for advanced geolocation data`,
    version: 'v2',
    cancelButton: true,
    graphic: DemoModalGeolocation,
    margin: '0 32px 0 32px'
  },
  [DemoModalVariants.PERMISSION_SHARING]: {
    header: `Upgrade to ${getPlanTypeName(PlanType.ENTERPRISE)} for sharing features.`,
    graphic: DemoModalPermissionSharing,
    footer:
      'We offer the only solution to collaboration on QR platforms. Unlock the ability to share Flowpages and Flowcodes. Grant different editing access in an organized team structure.',
    margin: '0 0 0 72px'
  },
  [DemoModalVariants.PERMISSION_SHARING_USE_CASES]: {
    header: `Upgrade to ${ProFlexPlanTypeName} for sharing features.`,
    graphic: DemoModalPermissionSharing,
    footer:
      'We offer the only solution to collaboration on QR platforms. Unlock the ability to share Flowpages and Flowcodes. Grant different editing access in an organized team structure.',
    margin: '0 0 0 72px',
    buttonLabel: 'Learn more',
    route: Routes.PRO_FLEX
  },
  [DemoModalVariants.ENTERPRISE_CODE_LIMIT_UPSELL]: {
    header: `Upgrade to ${getPlanTypeName(PlanType.ENTERPRISE)} to unlock more assets`,
    version: 'v2',
    cancelButton: true,
    graphic: DemoModalCodeLimit,
    margin: '0'
  },
  [DemoModalVariants.PRO_FLEX_CODE_LIMIT_UPSELL]: {
    header: `Upgrade to ${ProFlexPlanTypeName} for more assets`,
    version: 'v2',
    cancelButton: true,
    graphic: DemoModalCodeLimit,
    margin: '0'
  }
}
